import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useContent from 'store/content'
import { saveUserInput, getUserInput } from 'libs/localApi'

const InputSelect = ({ input }) => {
  const { options } = input
  const content = useContent()
  const appId = content.get.appId()
  const defaultValue = options.find((opt) => opt.default)?.value || ''
  const [value, setValue] = useState(defaultValue)
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    const userInput = getUserInput(appId) || {}
    const storedValue = userInput[input.name]
    if (storedValue) {
      setValue(storedValue)
    }
    setHydrated(true)
  }, [appId, input.name])

  const handleChange = (e) => {
    const newValue = e.target.value
    saveUserInput(appId, input.name, newValue)
    setValue(newValue)
  }

  if (!hydrated) {
    return null
  }

  return (
    <select value={value} onChange={handleChange}>
      {options.map((opt) => (
        <option
          value={opt.value}
          key={opt.value}
          disabled={opt.disabled}
        >
          {opt.name}
        </option>
      ))}
    </select>
  )
}

InputSelect.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    params: PropTypes.object,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        default: PropTypes.bool,
        disabled: PropTypes.bool,
      })
    ).isRequired,
  }).isRequired,
}

export default InputSelect
